<template>
  <div class="d-flex align-center">
    <v-btn icon @click="converterEmbalagem">
      <v-icon>mdi-repeat</v-icon>
    </v-btn>

    <span class="font-13 font-weight-medium">Embalagem {{ (pedido_selecionado.emb_master === 'S') ? 'Master' : 'Mínima' }}</span>
  </div>
</template>

<script>
import CompraAPI from "@/api/compra";
import {logout} from "@/helpers";

export default {
  name: "ConverterEmbalagemPedido",
  props: ['pedido_selecionado'],
  computed: {
    CALLBACK_ATUALIZAR_CARRINHO() {
      return this.$store.getters["CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho"]
    }
  },
  methods: {
    converterEmbalagem() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idpedido: this.pedido_selecionado.idpedido,
        emb: this.pedido_selecionado.emb_master === "S" ? "N" : "S",
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.converterEmbalagem(headers, params)
          .then((response) => {
            localStorage.token = response.data.token;
            this.CALLBACK_ATUALIZAR_CARRINHO();
          })
          .catch(logout)
          .finally(() => this.$store.dispatch("EmbalagemTelaDeCompras/setEmbalagemMaster", this.pedido_selecionado.emb_master === "S" ? false : true))
      );
    }
  }
}
</script>

<style scoped>

</style>
